module.exports = __webpack_public_path__ + "InterstateWGL-Bold.c6173800b6d2a5434b94.woff2";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/InterstateWGL-Bold.woff2
// module id = ../../../../../src/assets/layout/fonts/InterstateWGL-Bold.woff2
// module chunks = styles